/**
 * Sanitización y normalización de texto para inputs de mantenedoras.
 */

/** Quita caracteres de control y colapsa espacios internos (conserva un espacio al final mientras se escribe). */
export function sanitizeTextInput(raw: string): string {
  const cleaned = String(raw ?? '')
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .replace(/[^\S\n]+/g, ' ');
  return cleaned;
}

/** Primera letra no-espacio en mayúscula (respeta espacios iniciales). */
export function capitalizeFirstLetter(raw: string): string {
  const s = String(raw ?? '');
  if (!s) return s;
  return s.replace(/^(\s*)(\S)/, (_, ws: string, ch: string) => ws + ch.toUpperCase());
}

/** Sanitiza + capitaliza primera letra (uso en onChange de campos de nombre). */
export function sanitizeAndCapitalizeName(raw: string): string {
  return capitalizeFirstLetter(sanitizeTextInput(raw));
}

/** Trim final al salir del campo (blur / submit). */
export function finalizeTextInput(raw: string): string {
  return capitalizeFirstLetter(sanitizeTextInput(raw).trim());
}

const NO_CAPITALIZE_FIELDS = new Set([
  'email',
  'password',
  'username',
  'phone',
  'phone_number',
  'license_plate',
  'code',
]);

/** Sanitiza un campo de texto de formulario; capitaliza nombres/direcciones/marca. */
export function sanitizeFormTextField(fieldName: string, raw: string): string {
  const sanitized = sanitizeTextInput(raw);
  if (fieldName === 'license_plate' || fieldName === 'code') {
    return sanitized.toUpperCase();
  }
  if (NO_CAPITALIZE_FIELDS.has(fieldName)) {
    return sanitized;
  }
  return capitalizeFirstLetter(sanitized);
}

/** Finaliza (trim + reglas) al blur/submit. */
export function finalizeFormTextField(fieldName: string, raw: string): string {
  const trimmed = sanitizeTextInput(raw).trim();
  if (fieldName === 'license_plate' || fieldName === 'code') {
    return trimmed.toUpperCase();
  }
  if (NO_CAPITALIZE_FIELDS.has(fieldName)) {
    return trimmed;
  }
  return capitalizeFirstLetter(trimmed);
}
